import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowUpRight, Check, Loader2, MailX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Container } from "@/components/shared/PageHeader";
import { Seo } from "@/components/shared/Seo";
import { unsubscribeNewsletter, errorMessage } from "@/lib/api";

/** /nyheitsbrev/avmelding/:token – one click from the e-mail, and the address is off the list. */
export default function NewsletterUnsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState({ status: "loading" });
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    unsubscribeNewsletter(token).then((d) => setState({ status: "ok", email: d.email })).catch((e) => setState({ status: "error", message: errorMessage(e, "Lenkja er ugyldig") }));
  }, [token]);
  return (
    <div data-testid="newsletter-unsubscribe-page">
      <Seo title="Avmelding nyheitsbrev" description="Meld deg av nyheitsbrevet frå Halsnøy Kulturhus." />
      <Container className="py-20 sm:py-28">
        <div className="mx-auto max-w-lg text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-secondary text-foreground">
            {state.status === "loading" ? <Loader2 className="h-6 w-6 animate-spin" /> : state.status === "ok" ? <Check className="h-6 w-6" /> : <MailX className="h-6 w-6" />}
          </span>
          <h1 className="t-h2 mt-6 text-balance" data-testid="unsubscribe-title">{state.status === "loading" ? "Melder deg av …" : state.status === "ok" ? "Du er meld av" : "Fann ikkje påmeldinga"}</h1>
          <p className="mt-4 text-[17px] leading-relaxed text-muted-foreground" data-testid="unsubscribe-text">
            {state.status === "ok" ? <>Adressa {state.email} får ikkje fleire nyheitsbrev frå oss. Takk for at du var med – du er alltid velkomen innom huset.</> : state.status === "error" ? state.message : "Eit lite augeblikk."}
          </p>
          {state.status !== "loading" && (
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Button asChild size="lg" data-testid="unsubscribe-home-link"><Link to="/">Til framsida <ArrowUpRight className="h-4 w-4" /></Link></Button>
              <Button asChild variant="outline" size="lg"><Link to="/arrangement">Sjå programmet</Link></Button>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
}
